/* eslint-disable @typescript-eslint/no-explicit-any */

import { observable, action, computed } from 'mobx';

export class BaseFormModel {
    @observable validated: boolean = false;

    @action errorFor(name: string) {
        return this.validationErrorsName(name);
    }

    @action isValid(name: string): boolean {
        return !this.validationErrorsName(name).length;
    }

    @action setValue(name: string, value: string) {
        this[name] = value;
    }

    @action
    validationErrorsName(name: string) {
        const errors = this['__validateError_' + name[0].toUpperCase() + name.substr(1)];
        return errors ? errors : [];
    }

    @computed
    get isFormValid() {
        return this.__validators ? this.__isValidForm : true;
    }

    @computed
    get invalidFields() {
        return this.__errorFields || [];
    }

    @computed
    get formValidatedClass() {
        return this.validated ? 'validated' : 'not-validated';
    }

    @action validate(): boolean {
        this.validated = true;
        return this.isFormValid;
    }

    [key: string]: any;
}